var map = {
	"./Class_Air.png": 537,
	"./Class_Mage.png": 538,
	"./Class_Melee.png": 539,
	"./Class_None.png": 540,
	"./Class_Range.png": 541,
	"./Class_Tank.png": 542
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 274;